<template>
  <div class="reason-select">
    <div
      v-if="contactStore.isCustomerTypeCustomer"
      class="reason-select-warning type-customer"
    >
      <translate tag="p"
        >Please note that you're contacting Pitchup.com, not the campsite or
        holiday park. Unfortunately we're unable to take bookings over the
        phone.</translate
      >
      <translate tag="p"
        >If you need to amend your booking, please contact the site using the
        details in your confirmation email.</translate
      >

      <p>
        <i18n-t
          keypath="You can cancel a booking {userAccountBookingsLink} ({userAccountSignUpLink}), or by contacting the site using the details in your confirmation email."
        >
          <template #userAccountBookingsLink>
            <nuxt-link :to="$puLocalePath({ name: 'account-bookings' })">
              <translate>in your account</translate>
            </nuxt-link>
          </template>
          <template #userAccountSignUpLink>
            <nuxt-link :to="$puLocalePath({ path: '/accounts/signup/' })">
              <translate>sign up</translate>
            </nuxt-link>
          </template>
        </i18n-t>
        <nuxt-link
          :to="$puLocalePath({ path: '/about/faqs/can-i-cancel-my-booking/' })"
        >
          <translate>More information</translate>
        </nuxt-link>
      </p>

      <nuxt-link
        :to="$puLocalePath({ path: '/about/resend_confirmation_email/' })"
        class="primary button"
      >
        <translate>Resend my booking confirmation</translate>
      </nuxt-link>
    </div>
    <div class="losenge">
      <base-select
        :select-options="currentReasonsOptions"
        :required="true"
        name="reason"
        :default-select-name="defaultSelectName"
        @change="contactStore.updateReason($event.selectedValue)"
      >
        <template #label>
          <translate>Type of enquiry</translate>
        </template>
      </base-select>
    </div>
    <div
      v-if="contactStore.shouldShowCustomerCancelWarning"
      class="reason-select-warning"
    >
      <translate
        >To cancel or amend your booking, please follow the steps
        above.</translate
      >
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
/* TODO: Add proper typing to resolve type safety warnings */
import { ContactSubcategoriesServiceFetch } from '~/apps/contact/ContactSubcategoriesServiceFetch'
const contactStore = useContactStoreSetup(usePinia())
const { t } = useI18n()
const route = useRoute()
const lang = route.params.lang || 'en-gb'

const { data, error } = await useAsyncData(
  `contact-subcategories-${lang}`,
  () => {
    return new ContactSubcategoriesServiceFetch().fetch(lang as string)
  },
  // avoid duplicate requests server and client
  {
    server: true,
    lazy: process.client, // Defer fetching until client-side execution
    dedupe: 'cancel',
    getCachedData: (key, nuxt) => nuxt.payload.data[key] ?? undefined,
  },
)

if (error.value) {
  console.error(error.value)
}

const contactSubcategoriesReasonMap = computed(() => {
  return (
    data.value?.choices?.reason?.reduce((reasonMap, subcategoriesReason) => {
      reasonMap[subcategoriesReason.value] = subcategoriesReason.text
      return reasonMap
    }, {}) || {}
  )
})

const currentReasonsOptions = computed(() => {
  return contactStore.currentReasons.map((reason) => ({
    name: contactSubcategoriesReasonMap.value[reason] || reason,
    value: reason,
  }))
})

const defaultSelectName = computed(() => {
  return t('Please choose...')
})
</script>

<style scoped>
.reason-select {
  margin-bottom: 1em;
}
.reason-select-warning {
  background: #f9c1c1;
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  border-radius: 16px;
  padding: 1em;
  margin-bottom: 1.4em;
}
p + p {
  margin-bottom: 1em;
}
</style>
